<template>
    <div v-if="showModal">
        <b-modal
                v-model="showModalLocal"
                :title="'Гость'"
                class="modal-primary"
                size="md"
                ok-variant="primary"
                @hide.prevent
                @ok="handleOk"
                @cancel="handleCancel"
                @close="handleCancel"
                ref="my-modal"
        >

            <b-form-group
                    label="* Фамилия"
                    label-cols="4"
                    label-cols-sm="3"
                    :state="validateState('guest_surname')"
                    :invalid-feedback="veeErrors.first('guest_surname')"
            >
                <b-form-input type="text"
                              v-model="guest.surname"
                              v-validate="{max:30,required:true}"
                              :id="'guest_surname'"
                              :name="'guest_surname'"
                              data-vv-as="'Фамилия'"

                              :state="validateState('guest_surname')"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    label="Имя"
                    label-cols="4"
                    label-cols-sm="3"
                    :state="validateState('guest_name')"
                    :invalid-feedback="veeErrors.first('guest_name')"
            >
                <b-form-input type="text"
                              v-model="guest.name_"
                              v-validate="{max:30}"
                              :id="'guest_name'"
                              :name="'guest_name'"
                              data-vv-as="'Имя'"

                              :state="validateState('guest_name')"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    label="Отчество"
                    label-cols="4"
                    label-cols-sm="3"
                    :state="validateState('guest_patro')"
                    :invalid-feedback="veeErrors.first('guest_patro')"
            >
                <b-form-input type="text"
                              v-model="guest.patro"
                              v-validate="{max:30}"
                              :id="'guest_patro'"
                              :name="'guest_patro'"
                              data-vv-as="'Отчество'"

                              :state="validateState('guest_patro')"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    label="Документ"
                    label-cols="4"
                    label-cols-sm="3"
                    :state="validateState('guest_document_type')"
                    :invalid-feedback="veeErrors.first('guest_document_type')"
            >
                <b-form-input type="text"
                              v-model="guest.document_type"
                              v-validate="{max:100}"
                              :id="'guest_document_type'"
                              :name="'guest_document_type'"
                              data-vv-as="'Документ'"
                              :state="validateState('guest_document_type')"
                              :aria-describedby="'guest_document_type_feedback'"
                ></b-form-input>
            </b-form-group>
            <b-form-group
                    label="Дата рождения"
                    label-cols="4"
                    label-cols-sm="3"
                    :state="validateState('guest_date_birthday_iso')"
                    :invalid-feedback="veeErrors.first('guest_date_birthday_iso')"
            >
                <v-date-picker
                        :id="'check_in_date'"
                        v-model='guest.date_birthday_iso'
                        @change="onChangeDate()"
                        @input="onChangeDate()"
                        :clear-button-icon="'fas fa-times'"
                        :data-vv-name="'guest_date_birthday_iso'"
                >

                </v-date-picker>
            </b-form-group>
            <b-form-group
                    label="Возраст"
                    label-cols="4"
                    label-cols-sm="3"
            >
                <b-form-select id="'age'"
                               :plain="true"
                               value-field="id"
                               v-model="guest.age"
                >
                    <option value="255">Взрослый</option>
                    <option v-for="age in ages" :key="age" :value="age">{{formatAge(age)}}</option>
                </b-form-select>
            </b-form-group>
            <b-form-group
                    label="Тариф"
                    label-cols="4"
                    label-cols-sm="3"
                    :state="validateState('program')"
                    :invalid-feedback="veeErrors.first('program')"
            >
                <b-form-select id="'program'"
                               :plain="true"
                               value-field="id"
                               v-validate="{required:true}"
                               v-model="guest.t_obj_tariff_id"
                               :data-vv-name="'program'"
                               data-vv-as="'Тариф'"
                >
                    <option value="0" disabled style="display: none;">выберите тариф</option>
                    <option v-for="program in programs" :key="program.id" :value="program.id">{{program.title}}</option>
                </b-form-select>
            </b-form-group>

            <b-row>
                <b-col cols="3">
                    <b-form-group label="Доп. место"  description="принудительно считается дополнительное место">
                        <c-switch class="mx-1" color="primary" label variant="pill" v-model="guest.m_places_additionally" v-bind="labelIcon" />
                    </b-form-group>
                </b-col>
                <b-col v="3">
                    <b-form-group label="Пол">
                        <c-switch class="mx-1" :color="guest.m_women?'danger':'primary'" label variant="pill" v-model="guest.m_women" v-bind="sexText" />
                    </b-form-group>
                </b-col>
                <b-col cols="3">
                    <b-form-group label="Социальный" description="то применяются социальные скидки">
                        <c-switch class="mx-1" color="primary" label variant="pill" v-model="guest.apply_social_discount" v-bind="labelIcon" />
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="4">
                    <b-form-group
                            label="Сумма, ₽"
                            :state="validateState('guest_summa')"
                            :invalid-feedback="veeErrors.first('guest_summa')"
                    >
                        <b-form-input type="text"
                                      v-model="guest_summa"
                                      v-validate="{required:true,decimal:2,max_value:33000000,min_value:0}"
                                      :id="'guest_summa'"
                                      :name="'guest_summa'"
                                      data-vv-as="'сумма'"
                                      :state="validateState('guest_summa')"
                                      @input="onChangeSumm()"
                                      :readonly="!is_admin"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                            label="% скидки"
                            :state="validateState('guest_discount_percent')"
                            :invalid-feedback="veeErrors.first('guest_discount_percent')"
                    >
                        <b-form-input type="text"
                                      v-model="guest.discount_percent"
                                      v-validate="{numeric:true,max_value:100}"
                                      :id="'guest_discount_percent'"
                                      :name="'guest_discount_percent'"
                                      data-vv-as="'% скидки'"
                                      :state="validateState('guest_discount_percent')"
                                      @input="onChangeDP()"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                            label="Скидка, ₽"
                            :state="validateState('guest_discount_value')"
                            :invalid-feedback="veeErrors.first('guest_discount_value')"
                            >
                        <b-form-input type="text"
                                      v-model="guest_discount_value"
                                      v-validate="{required:true,decimal:2,max_value:33000000,min_value:0}"
                                      :id="'guest_discount_value'"
                                      :name="'guest_discount_value'"
                                      data-vv-as="'скидка'"
                                      :state="validateState('guest_discount_value')"
                                      @input="onChangeDV()"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                            label="К оплате, ₽"
                            :state="validateState('guest_with_discount_value')"
                            :invalid-feedback="veeErrors.first('guest_with_discount_value')"
                    >
                        <b-form-input type="text"
                                      v-model="guest_with_discount_value"
                                      v-validate="{decimal:2}"
                                      :id="'guest_with_discount_value'"
                                      :name="'guest_with_discount_value'"
                                      data-vv-as="'к оплате'"
                                      :state="validateState('guest_with_discount_value')"
                                      readonly
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                            label="% предоплаты"
                            :state="validateState('guest_prepay_percent')"
                            :invalid-feedback="veeErrors.first('guest_prepay_percent')"
                    >
                        <b-form-input type="text"
                                      v-model="guest_prepay_percent"
                                      v-validate="{numeric:true,max_value:100}"
                                      :id="'guest_prepay_percent'"
                                      :name="'guest_prepay_percent'"
                                      data-vv-as="'% предоплаты'"
                                      :state="validateState('guest_prepay_percent')"
                                      @input="onChangePP()"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col cols="4">
                    <b-form-group
                            label="Предоплата, ₽"
                            :state="validateState('guest_prepay_value')"
                            :invalid-feedback="veeErrors.first('guest_prepay_value')"
                    >
                        <b-form-input type="text"
                                      v-model="guest_prepay_value"
                                      v-validate="{required:true,decimal:2,max_value:33000000,min_value:0}"
                                      :id="'guest_prepay_value'"
                                      :name="'guest_prepay_value'"
                                      data-vv-as="'предоплата'"
                                      :state="validateState('guest_prepay_value')"
                                      @input="onChangePV()"
                        ></b-form-input>
                    </b-form-group>
                </b-col>

            </b-row>


            <b-form-group>
                <label for="guest_comment_text">Комментарий</label>
                <b-form-input type="text"
                              v-model="guest.comment_text"
                              v-validate="{max:200}"
                              :id="'guest_comment_text'"
                              :name="'guest_comment_text'"
                              data-vv-as="'Комментарий'"
                              :state="validateState('guest_comment_text')"
                              :aria-describedby="'guest_comment_text_feedback'"
                ></b-form-input>
                <b-form-invalid-feedback :id="'guest_comment_text_feedback'"> {{ veeErrors.first('guest_comment_text') }}</b-form-invalid-feedback>
            </b-form-group>


            <template slot="modal-footer" slot-scope="{ ok, cancel, close }">
                <b-button size="sm" variant="outline-success" @click="ok()">
                    Закрыть
                </b-button>
            </template>
        </b-modal>

<!--        <datalist id="names_list"><option v-for="s in popular_names" :value='s'></option></datalist>-->
<!--        <datalist id="patros_list"><option v-for="s in popular_patros" :value='s'></option></datalist>-->
<!--        <datalist id="families_list"><option v-for="s in popular_families" :value='s'></option></datalist>-->

    </div>
</template>


<script>
    import { functions } from '@/functions';
    import { functions_names } from '@/functions_names';
    import { Switch as cSwitch } from '@coreui/vue'

    export default {
        components: {
            cSwitch,
        },
        name: 'GuestEditDialog',
        mixins: [functions, functions_names],
        data: function () {
            return {
                ages:this.range(0,100),
                labelIcon: { dataOn: '\u2713', dataOff: '\u2715' },
                labelTxt: { dataOn: 'да', dataOff: 'нет' },
                sexText: { dataOn: 'жен', dataOff: 'муж' },
            };
        },
        model: {
            prop: "showModal",
            event: "hide"
        },
        props: {
            showModal: [Number, Boolean],
            guest:Object,
            programs:Array
        },
        watch: {
        },
        methods: {
            handleCancel: function () {
                this.$emit("hide", false);
            },
            handleOk: function () {
                this.$emit("hide", false);
            },
            handleSubmit: function () {
                this.$emit("hide", false);
            },

            initGuestValues() {
                if (!this.guest.summa) {
                    this.guest.summa = 0;
                }
                if (!this.guest.discount_percent) {
                    this.guest.discount_percent = 0;
                }
                if (!this.guest.discount_value) {
                    this.guest.discount_value = 0;
                }
                if (!this.guest.with_discount_value) {
                    this.guest.with_discount_value = 0;
                }
                if (!this.guest.prepay_percent) {
                    this.guest.prepay_percent = 0;
                }
                if (!this.guest.prepay_value) {
                    this.guest.prepay_value = 0;
                }
            },
            calculateVoucherTotals: function () {
                this.$emit("update");
            },
            onChangeSumm: function () {
                this.initGuestValues();
                if (this.guest.discount_percent) {
                    this.guest.discount_value = Math.round(this.guest.summa / 100.0 * this.guest.discount_percent);
                }
                this.guest.with_discount_value = this.guest.summa - this.guest.discount_value;
                if (this.guest.prepay_percent) {
                    this.guest.prepay_value = Math.round(this.guest.with_discount_value / 100.0 * this.guest.prepay_percent)
                }
                this.calculateVoucherTotals();
            },
            onChangeDP: function () {
                this.guest.discount_value = Math.round(this.guest.summa / 100.0 * this.guest.discount_percent);
                this.guest.with_discount_value = Math.round(this.guest.summa - this.guest.discount_value);
                if (this.guest.prepay_percent) {
                    this.guest.prepay_value = Math.round(this.guest.with_discount_value / 100.0 * this.guest.prepay_percent)
                }
                this.calculateVoucherTotals();
            },
            onChangeDV: function () {
                this.guest.discount_percent = 0;
                this.guest.with_discount_value = this.guest.summa - this.guest.discount_value;

                if (this.guest.prepay_percent) {
                    this.guest.prepay_value = Math.round(this.guest.with_discount_value / 100.0 * this.guest.prepay_percent)
                }
                this.calculateVoucherTotals();
            },
            onChangePP: function () {
                if (this.guest.prepay_percent) {
                    this.guest.prepay_value = Math.round(this.guest.with_discount_value / 100.0 * this.guest.prepay_percent)
                }
                this.calculateVoucherTotals();
            },
            onChangePV: function () {
                this.guest.prepay_percent = 0;
                this.calculateVoucherTotals();
            },
            onChangeDate: function () {
                this.guest.age = Math.floor(Math.abs(new Date() - this.guest.date_birthday_iso) / 31557600000);
            },
            onChangeAge: function () {
                this.guest.date_birthday_iso = null;
            },
            onChangeProgram: function () {
//                if (this.voucher.m_only_number && (i===0)) {
//                    this.resetPerson(0);
//                    for (let i=1;i<this.guests.length; i++) {
//                        this.guest.t_obj_tariff_id = this.guests[0].t_obj_tariff_id;
//                        this.resetPerson();
//                    }
//                }
//                else if (this.voucher.m_only_number && (i!==0)) {
//                    alert("Shit happens!");
//                }
//                else if (!this.voucher.m_only_number) {
//                    this.resetPerson();
//                }
            },
        },
        computed: {
            showModalLocal: {
                get: function () {
                    return this.showModal
                },
                set: function (newValue) {}
            },

            guest_summa:  {
                get: function () {
                    return this.guest.summa/100;
                },
                set: function (newValue) {
                    this.guest.summa = newValue*100;
                }
            },
            guest_discount_value:  {
                get:  function(){
                    return this.guest.discount_value/100;
                },
                set: function (newValue) {
                    this.guest.discount_value = newValue*100;
                }
            },
            guest_with_discount_value: {
                get:function()   {
                    return this.guest.with_discount_value/100;
                },
                set: function (newValue) {
                    this.guest.with_discount_value = newValue*100;
                }
            },
            guest_prepay_percent: {
                get:function()  {
                    return this.guest.prepay_percent;
                },
                set: function (newValue) {
                    this.guest.prepay_percent = newValue;
                }
            },
            guest_prepay_value:  {
                get:function()  {
                    return this.guest.prepay_value/100;
                },
                set: function (newValue) {
                    this.guest.prepay_value = newValue*100;
                }
            },
        },
        created: function() {
        },
        mounted: function() {
        },
        updated: function() {
        },
    }
</script>
